jQuery(document).ready(function () {

	/* Theme Options
	-------------------------------------------------------------- */

	jQuery(".scheme").click(function () {

		jQuery(".scheme").removeClass("active");
		jQuery(this).addClass("active");

		var currentColorScheme = jQuery(this).attr("data-scheme");

		jQuery("body").removeAttr("data-color-scheme");
		jQuery("body").attr("data-color-scheme", currentColorScheme);

	});

	jQuery(".video-option .checkbox").click(function () {

		jQuery(this).toggleClass("active");

		jQuery(".banner").toggleClass("video novideo");

	});

	/* Mobile menu button and dropdown
	-------------------------------------------------------------- */

	jQuery('#nav-icon3').click(function () {
		jQuery(this).toggleClass('open');
	});

	jQuery(".top-bar .menu-item-has-children").click(function () {
		jQuery(this).children(".sub-menu").toggle();
	});

	jQuery(".mobile-menu-btn").click(function () {
		jQuery(".menu-main-menu-container").toggle();
	});

	/* Remove # from main menu items
	-------------------------------------------------------------- */

	jQuery("ul > li > a[href='#']").removeAttr("href");

	/* Slick Slider
	-------------------------------------------------------------- */

	// Wait for Slick plugin to be loaded before initializing
	function initSliders() {
		if (typeof jQuery.fn.slick === 'undefined') {
			// Slick not loaded yet, retry after 100ms
			setTimeout(initSliders, 100);
			return;
		}

		jQuery('#proven-experiance .experience-slider').slick({
			slidesToShow: 3,
			useTransform: true,
			cssEase: 'ease-in-out',
			speed: 1000,
			arrows: true,
			nextArrow: '#proven-experiance .next-arrow',
			prevArrow: '#proven-experiance .prev-arrow',
			adaptiveHeight: true,
			responsive: [
				{
					breakpoint: 1145,
					settings: {
						slidesToShow: 1,
					}
				},
				{
					breakpoint: 767,
					settings: {
						slidesToShow: 1,
						arrows: false,
						dots: true
					}
				}
			]
		});

		jQuery('#trust-logos .trust-logos-slider').slick({
			slidesToShow: 5,
			useTransform: true,
			cssEase: 'ease-in-out',
			speed: 1000,
			arrows: true,
			nextArrow: '#trust-logos .next-arrow',
			prevArrow: '#trust-logos .prev-arrow',
			responsive: [
				{
					breakpoint: 1279,
					settings: {
						slidesToShow: 3,
					}
				},
				{
					breakpoint: 1145,
					settings: {
						slidesToShow: 2,
					}
				},
				{
					breakpoint: 767,
					settings: {
						slidesToShow: 1
					}
				}
			]
		});

		jQuery('#testimonials-slider .testimonials-slider').slick({
			slidesToShow: 1,
			useTransform: true,
			cssEase: 'ease-in-out',
			speed: 1000,
			arrows: true,
			dots: false,
			adaptiveHeight: false,
			nextArrow: '#testimonials-slider .next-arrow',
			prevArrow: '#testimonials-slider .prev-arrow',
			responsive: [
				{
					breakpoint: 1145,
					settings: {
						arrows: false
					}
				}
			]
		});
	}

	// Initialize sliders when Slick is ready
	initSliders();

	/* Lazy Load Images on scroll
	-------------------------------------------------------------- */

	// Wait for ScrollMagic to be loaded
	function initScrollMagic() {
		if (typeof ScrollMagic === 'undefined') {
			setTimeout(initScrollMagic, 100);
			return;
		}

		var controller = new ScrollMagic.Controller();

		new ScrollMagic.Scene({
			triggerElement: ".banner"
		})
			.setClassToggle(".delay-load", "add-background")
			//.addIndicators()
			.triggerHook(0)
			.reverse(false)
			.addTo(controller);

		/* 
		-------------------------------------------------------------- */

		function lazyLoad() {
			var getImgData = jQuery('.lazy-inline').each(function () {
				var results = jQuery(this).attr("data-src");
				var newResults = jQuery(this).attr("src", results);
			});
		}

		new ScrollMagic.Scene({
			triggerElement: ".banner"
		})
			.on('start', function () {
				lazyLoad();
			})
			.reverse(false)
			//.addIndicators()
			.triggerHook(0)
			.addTo(controller);
	}

	// Initialize ScrollMagic when ready
	initScrollMagic();

	/* Smooth Scroll to #
	-------------------------------------------------------------- */

	jQuery(".smooth-scroll").click(function (event) {
		event.preventDefault();
		jQuery('html,body').animate({
			scrollTop: jQuery(this.hash).offset().top
		}, 1500);
	});


	/* Go To Top
	-------------------------------------------------------------- */
	jQuery('.jef-go-to-top').on('click', evt => {
		jQuery('html,body').animate({
			scrollTop: 0
		}, 1000);
	});

	/* Why choose us tabs
	-------------------------------------------------------------- */

	jQuery("#why-choose-us #one").addClass("active");

	jQuery("#why-choose-us .reason").click(function () {

		var clickedId = jQuery(this).attr('id');

		jQuery("#why-choose-us .reason").removeClass("active");
		jQuery("#why-choose-us .answer-box").removeClass("active");

		jQuery(this).addClass("active");
		jQuery("#why-choose-us .answer-box#" + clickedId).addClass("active");

	});

	/* Practice Area Modal
	-------------------------------------------------------------- */

	jQuery("#practice-areas .practice-area").click(function () {

		jQuery("html").addClass("no-overflow");
		jQuery("#practice-areas .modal-content .content-to-clone").empty();
		jQuery(this).children(".content-to-clone").clone().appendTo("#practice-areas .modal-content");
		jQuery("#practice-areas .modal-content").fadeIn('fast');

	});

	jQuery("#close-modal").click(function () {

		jQuery("html").removeClass("no-overflow");
		jQuery(".modal-content").fadeOut('fast');

	});


	function handleScroll() {
		if (window.scrollY >= 50) {
			if (!document.body.classList.contains('scrolled')) {
				document.body.classList.add('scrolled');
			}
		} else {
			document.body.classList.remove('scrolled');
		}
	}

	window.addEventListener('scroll', handleScroll);

	handleScroll();

	window.addEventListener('pagehide', () => {
		window.removeEventListener('scroll', handleScroll);
	});

}); // End Document Ready